"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_DIFFERENT_DEVICE = exports.USE_DIFFERENT_BROWSER = exports.SELECT_WORKING_MICROPHONE = exports.ReadinessCheckerMessagingMap = exports.NO_MICROPHONE_FOUND = exports.NO_CAMERA_SELECTED = exports.NO_CAMERA_FOUND = exports.NO_AUDIO_OUTPUT_ERROR = exports.NO_AUDIO_OUTPUT = exports.NETWORK_TRAFFIC_ERROR = exports.MICROPHONE_IN_USE_MESSAGE = exports.CANNOT_HEAR_AUDIO = exports.CAMERA_NOT_WORKING = exports.CAMERA_IN_USE_MESSAGE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ReadinessCheckerMess;
var NO_CAMERA_SELECTED = exports.NO_CAMERA_SELECTED = 'NO_CAMERA_SELECTED';
var NO_AUDIO_OUTPUT = exports.NO_AUDIO_OUTPUT = 'NO_AUDIO_OUTPUT';
var SELECT_WORKING_MICROPHONE = exports.SELECT_WORKING_MICROPHONE = 'SELECT_WORKING_MICROPHONE';
var CANNOT_HEAR_AUDIO = exports.CANNOT_HEAR_AUDIO = 'CANNOT_HEAR_AUDIO';
var NO_AUDIO_OUTPUT_ERROR = exports.NO_AUDIO_OUTPUT_ERROR = 'NO_AUDIO_OUTPUT_ERROR';
var NO_CAMERA_FOUND = exports.NO_CAMERA_FOUND = 'NO_CAMERA_FOUND';
var CAMERA_NOT_WORKING = exports.CAMERA_NOT_WORKING = 'CAMERA_NOT_WORKING';
var USE_DIFFERENT_DEVICE = exports.USE_DIFFERENT_DEVICE = 'USE_DIFFERENT_DEVICE';
var USE_DIFFERENT_BROWSER = exports.USE_DIFFERENT_BROWSER = 'USE_DIFFERENT_BROWSER';
var NO_MICROPHONE_FOUND = exports.NO_MICROPHONE_FOUND = 'NO_MICROPHONE_FOUND';
var NETWORK_TRAFFIC_ERROR = exports.NETWORK_TRAFFIC_ERROR = 'NETWORK_TRAFFIC_ERROR';
var CAMERA_IN_USE_MESSAGE = exports.CAMERA_IN_USE_MESSAGE = 'CAMERA_IN_USE_MESSAGE';
var MICROPHONE_IN_USE_MESSAGE = exports.MICROPHONE_IN_USE_MESSAGE = 'MICROPHONE_IN_USE_MESSAGE';
var ReadinessCheckerMessagingMap = exports.ReadinessCheckerMessagingMap = (_ReadinessCheckerMess = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ReadinessCheckerMess, NO_CAMERA_SELECTED, {
  title: 'Select a working camera',
  content: '',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), NO_AUDIO_OUTPUT, {
  title: 'No audio output found',
  content: '',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), SELECT_WORKING_MICROPHONE, {
  title: 'Select a working microphone',
  content: '',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), NO_AUDIO_OUTPUT_ERROR, {
  title: 'No audio output found',
  content: 'Go back to settings to select an audio output.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), NO_CAMERA_FOUND, {
  title: 'No camera found',
  content: 'Go back to settings to select a camera.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), CAMERA_NOT_WORKING, {
  title: 'Camera not working',
  content: 'Go back to settings to select a camera.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), NETWORK_TRAFFIC_ERROR, {
  title: 'Network traffic error',
  content: "We've detected that your device is restricting outbound traffic. Follow the troubleshooting steps in our help article or contact your IT team for help.",
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/What-are-the-hardware-and-software-requirements-for-Studio-in-Attendee-Hub'
}), USE_DIFFERENT_DEVICE, {
  title: 'Use a different device',
  content: 'Use a desktop or laptop computer to continue.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), USE_DIFFERENT_BROWSER, {
  title: 'Use a different browser',
  content: 'Use Chrome or Edge to continue.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), NO_MICROPHONE_FOUND, {
  title: 'No microphone found',
  content: 'Go back to settings to select a microphone.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])(_ReadinessCheckerMess, CAMERA_IN_USE_MESSAGE, {
  title: 'No camera found',
  content: 'Your camera is currently in use by another app. Close it to access your camera.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}), MICROPHONE_IN_USE_MESSAGE, {
  title: 'No Microphone found',
  content: 'Your microphone is currently in use by another app. Close it to access your microphone.',
  learnMoreLink: 'https://support.cvent.com/s/communityarticle/Understanding-Studio-Compatibility'
}));